module.exports = __webpack_public_path__ + "static/installationspartner-extraimg1@2x-min-989ec64569cd52cb23ef323bcfe5d76d.png";